export default __webpack_public_path__ + "static/media/cross.29b4528f.svg";